import React from 'react'
import './error-fallback.styles.scss'

import icon from '@/assets/eln-logo-blue.png'

const ErrorFallback = ({ error, onReload, onGoHome }) => {

  return (
    <div className="error-fallback-page">
      <div className="container">
        <div className="image">
          <img src={icon} alt="Error" />
        </div>
        <div className="content">
          <h1>Something Went Wrong</h1>
          <p>Sorry about that. An unexpected error occurred and this part of the page couldn&apos;t be displayed. Our team has been notified.</p>
          <div className="g-space-1"></div>
          <div className="buttons">
            <button className="g-button primary" onClick={onReload}>Reload Page</button>
            <button className="g-button" onClick={onGoHome}>Go Home</button>
          </div>
          {
            import.meta.env.DEV && error &&
            <details className="error-details">
              <summary>Error details (visible in development only)</summary>
              <pre>{error.stack || error.message || String(error)}</pre>
            </details>
          }
        </div>
      </div>
    </div>
  )
}

export default ErrorFallback
